import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../utils/ToastEmitter";

type PATCH_UPDATE_CASE_AUTO_CLOSE_REQUEST = {
  caseId: string;
};

function patchUpdateCaseAutoClose({
  caseId,
}: PATCH_UPDATE_CASE_AUTO_CLOSE_REQUEST) {
  return fetcher({
    url: `v1/cases/${caseId}/auto-close/reset`,
    method: "PATCH",
  });
}

function usePatchUpdateCaseAutoClose(onSuccess?: () => void) {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: patchUpdateCaseAutoClose,
    onSuccess: () => {
      showToast(t("Case_Auto_Close_Updated_Successfully"), "success");
      onSuccess?.();
    },
    onError: () => {
      showToast(t("Failed_to_Update_Case_Auto_Close"), "error");
    },
  });
}
export default usePatchUpdateCaseAutoClose;